/* global $:true module:true Flickity:true Foundation:true */

import debug from "debug";
const MODULE_NAME = 'core/modules/sliders';
const ELEMENT_SELECTOR = '.block-slider';
const log = debug(MODULE_NAME);

$(() => {
	if ($(ELEMENT_SELECTOR).length) {
		System.import(
			/* webpackChunkName: "block-slider" */ './blocks'
		).then((module) => {
			module.default();
		});
	}
});



// WEBPACK FOOTER //
// ./client/src/core/components/sliders/index.js